import Utils from "../../../shared/utils";

export const MOUSE_ANIMATION = Utils.buildProductPageImageLink("rent/safecheck/mouse-animation.svg")
